export type BorderRadius = keyof typeof BORDER_RADIUS;
export const BORDER_RADIUS = {
    0: '0',
    25: '2px',
    50: '4px',
    100: '8px',
    200: '16px',
    '50p': '50%',
} as const;
